"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const FilterList_1 = __importDefault(require("@material-ui/icons/FilterList"));
const ImportExport_1 = __importDefault(require("@material-ui/icons/ImportExport"));
const NavigateBefore_1 = __importDefault(require("@material-ui/icons/NavigateBefore"));
const NavigateNext_1 = __importDefault(require("@material-ui/icons/NavigateNext"));
const Replay_1 = __importDefault(require("@material-ui/icons/Replay"));
const react_table_1 = require("@tanstack/react-table");
const react_1 = require("react");
const hooks_1 = require("hooks");
function Table({ data, columns }) {
    const [sorting, setSorting] = (0, react_1.useState)([]);
    const [filtering, setFiltering] = (0, react_1.useState)('');
    const table = (0, react_table_1.useReactTable)({
        data,
        columns,
        getCoreRowModel: (0, react_table_1.getCoreRowModel)(),
        getPaginationRowModel: (0, react_table_1.getPaginationRowModel)(),
        getSortedRowModel: (0, react_table_1.getSortedRowModel)(),
        getFilteredRowModel: (0, react_table_1.getFilteredRowModel)(),
        state: {
            sorting: sorting,
            globalFilter: filtering,
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setFiltering,
        enableSortingRemoval: true,
    });
    const handlePrev = () => {
        table.previousPage();
    };
    const handleNext = () => {
        table.nextPage();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "filterable-sortable-table", children: [(0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: table.getHeaderGroups().map((headerGroup) => ((0, jsx_runtime_1.jsx)("tr", { children: headerGroup.headers.map((header) => ((0, jsx_runtime_1.jsx)("th", { children: (0, jsx_runtime_1.jsx)("div", { children: (0, react_table_1.flexRender)((0, jsx_runtime_1.jsxs)("div", { className: "sort-controls", children: [header.column.columnDef.header, header.column.getCanSort() && ((0, jsx_runtime_1.jsx)("div", { onClick: header.column.getToggleSortingHandler(), role: "button", tabIndex: 0, onKeyDown: (e) => {
                                                    if (e.key === 'Enter') {
                                                        header.column.getToggleSortingHandler();
                                                    }
                                                }, children: (0, jsx_runtime_1.jsx)(ImportExport_1.default, { fontSize: "small", className: "sort-or-filter-icon" }) })), header.column.getCanFilter() && ((0, jsx_runtime_1.jsx)(FilterContainer, { header: header, table: table }))] }), header.getContext()) }) }, header.id))) }, headerGroup.id))) }), (0, jsx_runtime_1.jsx)("tbody", { children: table.getRowModel().rows.map((row) => ((0, jsx_runtime_1.jsx)("tr", { children: row.getVisibleCells().map((cell) => ((0, jsx_runtime_1.jsx)("td", { children: (0, react_table_1.flexRender)(cell.column.columnDef.cell, cell.getContext()) }, cell.id))) }, row.id))) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "filterable-sortable-pagination", children: [(0, jsx_runtime_1.jsx)("button", { onClick: handlePrev, disabled: !table.getCanPreviousPage(), children: (0, jsx_runtime_1.jsx)(NavigateBefore_1.default, {}) }), (0, jsx_runtime_1.jsx)("div", { children: "Page" }), (0, jsx_runtime_1.jsxs)("strong", { children: [table.getState().pagination.pageIndex + 1, " of ", table.getPageCount()] }), (0, jsx_runtime_1.jsx)("button", { onClick: handleNext, disabled: !table.getCanNextPage(), children: (0, jsx_runtime_1.jsx)(NavigateNext_1.default, {}) })] })] }));
}
exports.default = Table;
function FilterContainer({ header, table, }) {
    const modalRef = (0, react_1.useRef)(null);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    (0, hooks_1.useOnClickOutside)(modalRef, () => setIsOpen(false));
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { onClick: () => {
                    setIsOpen(!isOpen);
                }, role: "button", tabIndex: 0, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        setIsOpen(!isOpen);
                    }
                }, children: (0, jsx_runtime_1.jsx)(FilterList_1.default, { fontSize: "small", className: "sort-or-filter-icon" }) }), isOpen && ((0, jsx_runtime_1.jsxs)("div", { className: "filter-modal", ref: modalRef, children: [(0, jsx_runtime_1.jsx)(Filter, { column: header.column, table: table }), (0, jsx_runtime_1.jsx)(Close_1.default, { onClick: () => {
                            setIsOpen(!isOpen);
                        }, className: "filter-close", "aria-label": "Close Filter", fontSize: "small" })] }))] }));
}
function Filter({ column, table, }) {
    const firstValue = table
        .getPreFilteredRowModel()
        .flatRows[0]?.getValue(column.id);
    const columnFilterValue = column.getFilterValue();
    const sortedUniqueValues = (0, react_1.useMemo)(() => typeof firstValue === 'number'
        ? []
        : Array.from(column.getFacetedUniqueValues().keys()).sort(), [column.getFacetedUniqueValues()]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("datalist", { id: column.id + 'list', children: sortedUniqueValues.slice(0, 5000).map((value) => ((0, jsx_runtime_1.jsx)("option", { value: value }, value))) }), (0, jsx_runtime_1.jsxs)("div", { className: "input-and-reset", children: [(0, jsx_runtime_1.jsx)(DebouncedInput, { type: "text", value: (columnFilterValue ?? ''), onChange: (value) => column.setFilterValue(value), placeholder: "Type to filter...", className: "w-36 border shadow rounded", list: column.id + 'list' }), (0, jsx_runtime_1.jsx)("div", { onClick: () => {
                            column.setFilterValue('');
                        }, role: "button", tabIndex: 0, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                column.setFilterValue('');
                            }
                        }, className: "reset-icon", children: (0, jsx_runtime_1.jsx)(Replay_1.default, {}) })] }), (0, jsx_runtime_1.jsx)("div", { className: "h-1" })] }));
}
// A debounced input react component
function DebouncedInput({ value: initialValue, onChange, debounce = 500, ...props }) {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    (0, react_1.useEffect)(() => {
        setValue(initialValue);
    }, [initialValue]);
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);
        return () => clearTimeout(timeout);
    }, [value]);
    return ((0, jsx_runtime_1.jsx)("input", { ...props, value: value, onChange: (e) => setValue(e.target.value) }));
}
